import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Home, BookOpen, Map, Building2, Compass } from 'lucide-react';

const navItems = [
  { path: '/china', label: 'China Hub', icon: Home },
  { path: '/china/planning', label: 'Planning', icon: BookOpen },
  { path: '/china/itineraries', label: 'Itineraries', icon: Map },
  { path: '/china/cities', label: 'Cities', icon: Building2 },
  { path: '/china/resources', label: 'Resources', icon: Compass },
];

interface ChinaEssentialsMiniNavProps {
  className?: string;
}

export function ChinaEssentialsMiniNav({ className }: ChinaEssentialsMiniNavProps) {
  const location = useLocation();

  return (
    <nav className={cn("bg-muted/50 rounded-lg p-4", className)}>
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-3">
        China Essentials
      </p>
      <div className="flex flex-wrap gap-2">
        {navItems.map(({ path, label, icon: Icon }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              className={cn(
                "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors",
                isActive 
                  ? "bg-primary text-primary-foreground" 
                  : "bg-background hover:bg-primary/10 text-foreground"
              )}
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
